module.exports = __webpack_public_path__ + "img/my_sites2.3a80017.svg";